import { useContext, useState, useEffect, forwardRef } from "react";
import { Row, Col, Form, Card } from "react-bootstrap";
import {
  BGL_SETTINGS,
  END,
  POST_BREAKFAST,
  POST_DINNER,
  POST_LUNCH,
  START,
  DefaultBreakfastStart,
  DefaultBreakfastEnd,
  DefaultLunchStart,
  DefaultLunchEnd,
  DefaultDinnerStart,
  DefaultDinnerEnd,
  DefaultFastingStart,
  DefaultFastingEnd,
  DefaultOvernightStart,
  DefaultOvernightEnd,
  OVERNIGHT,
  FASTING
} from "../../util/const";
import { PatientContext } from "../ActivePatients";
import { ValidationContext } from "../PatientForm";

const BglSettings = forwardRef<HTMLFormElement>((props, ref) => {

  const context = useContext(PatientContext);
  const validationContext = useContext(ValidationContext);

  const [override] = useState(context.patient.overrideDefaults);
  const [fastStart, setFastStart] = useState(context.patient.fastingStart);
  const [fastEnd, setFastEnd] = useState(context.patient.fastingEnd);
  const [breakStart, setBreakStart] = useState(context.patient.breakfastStart);
  const [breakEnd, setBreakEnd] = useState(context.patient.breakfastEnd);
  const [lunchStart, setLunchStart] = useState(context.patient.lunchStart);
  const [lunchEnd, setLunchEnd] = useState(context.patient.lunchEnd);
  const [dinnerStart, setDinnerStart] = useState(context.patient.dinnerStart);
  const [dinnerEnd, setDinnerEnd] = useState(context.patient.dinnerEnd);
  const [overnightStart, setOvernightStart] = useState(context.patient.overnightStart);
  const [overnightEnd, setOvernightEnd] = useState(context.patient.overnightEnd);

  // const toggleOverride = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setOverride(e.target.checked);
  //   context.patient.overrideDefaults = e.target.checked;
  // };

  useEffect(() => {
    if (override === false) {
      setFastStart(DefaultFastingStart);
      context.patient.fastingStart = DefaultFastingStart;
      setFastEnd(DefaultFastingEnd);
      context.patient.fastingEnd = DefaultFastingEnd;
      setBreakStart(DefaultBreakfastStart);
      context.patient.breakfastStart = DefaultBreakfastStart;
      setBreakEnd(DefaultBreakfastEnd);
      context.patient.breakfastEnd = DefaultBreakfastEnd;
      setLunchStart(DefaultLunchStart);
      context.patient.lunchStart = DefaultLunchStart;
      setLunchEnd(DefaultLunchEnd);
      context.patient.lunchEnd = DefaultLunchEnd;
      setDinnerStart(DefaultDinnerStart);
      context.patient.dinnerStart = DefaultDinnerStart;
      setDinnerEnd(DefaultDinnerEnd);
      context.patient.dinnerEnd = DefaultDinnerEnd;
      setOvernightStart(DefaultOvernightStart);
      context.patient.overnightStart = DefaultOvernightStart;
      setOvernightEnd(DefaultOvernightEnd);
      context.patient.overnightEnd = DefaultOvernightEnd;
    }
  }, [override, context.patient]);

  return (
    <Form noValidate validated={validationContext.hasValidated} ref={ref}>
      <Card className="mb-3">
        <Card.Header>{BGL_SETTINGS}</Card.Header>
        <Card.Body>
          <Row className="mt-2">
            {/* <Col sm={2} /> */}
            <Col sm={2}>{FASTING}</Col>
            <Col sm={2}>{POST_BREAKFAST}</Col>
            <Col sm={2}>{POST_LUNCH}</Col>
            <Col sm={2}>{POST_DINNER}</Col>
            <Col sm={2}>{OVERNIGHT}</Col>
          </Row>
        <Row className="middle">
          {/* <Form.Group as={Col} sm={2} className="mt-2" controlId="override">
            <Form.Check
              id="switch-override"
              defaultChecked = {override}
              type="switch"
              onChange={toggleOverride}
              label={OVERRIDE_DEFAULTS}
            />
          </Form.Group> */}
          <Form.Group as={Col} sm={1} className="mt-2" controlId="fast-start">
            <Form.FloatingLabel label={START} className="text-secondary">
              <Form.Control
                type="time"
                value={fastStart}
                onChange={(e) => {
                  setFastStart(e.target.value);
                  context.patient.fastingStart = e.target.value;
                }}
                required
                disabled={override === true ? false : true} />
            </Form.FloatingLabel>
          </Form.Group>
          <Form.Group as={Col} sm={1} className="mt-2" controlId="fast-end">
            <Form.FloatingLabel label={END} className="text-secondary">
              <Form.Control
                type="time"
                value={fastEnd}
                onChange={(e) => {
                  setFastEnd(e.target.value);
                  context.patient.fastingEnd = e.target.value;
                }}
                required
                disabled={override === true ? false : true} />
            </Form.FloatingLabel>
          </Form.Group>
          <Form.Group as={Col} sm={1} className="mt-2" controlId="break-start">
            <Form.FloatingLabel label={START} className="text-secondary">
              <Form.Control
                type="time"
                value={breakStart}
                onChange={(e) => {
                  setBreakStart(e.target.value);
                  context.patient.breakfastStart = e.target.value;
                }}
                required
                disabled={override === true ? false : true} />
            </Form.FloatingLabel>
          </Form.Group>
          <Form.Group as={Col} sm={1} className="mt-2" controlId="break-end">
            <Form.FloatingLabel label={END} className="text-secondary">
              <Form.Control
                type="time"
                value={breakEnd}
                onChange={(e) => {
                  setBreakEnd(e.target.value);
                  context.patient.breakfastEnd = e.target.value;
                }}
                required
                disabled={override === true ? false : true} />
            </Form.FloatingLabel>
          </Form.Group>
          <Form.Group as={Col} sm={1} className="mt-2" controlId="lunch-start">
            <Form.FloatingLabel label={START} className="text-secondary">
              <Form.Control
                type="time"
                value={lunchStart}
                onChange={(e) => {
                  setLunchStart(e.target.value);
                  context.patient.lunchStart = e.target.value;
                }}
                required
                disabled={override === true ? false : true} />
            </Form.FloatingLabel>
          </Form.Group>
          <Form.Group as={Col} sm={1} className="mt-2" controlId="lunch-end">
            <Form.FloatingLabel label={END} className="text-secondary">
              <Form.Control
                type="time"
                value={lunchEnd}
                onChange={(e) => {
                  setLunchEnd(e.target.value);
                  context.patient.lunchEnd = e.target.value;
                }}
                required
                disabled={override === true ? false : true} />
            </Form.FloatingLabel>
          </Form.Group>
          <Form.Group as={Col} sm={1} className="mt-2" controlId="dinner-start">
            <Form.FloatingLabel label={START} className="text-secondary">
              <Form.Control
                type="time"
                value={dinnerStart}
                onChange={(e) => {
                  setDinnerStart(e.target.value);
                  context.patient.dinnerStart = e.target.value;
                }}
                required
                disabled={override === true ? false : true} />
            </Form.FloatingLabel>
          </Form.Group>
          <Form.Group as={Col} sm={1} className="mt-2" controlId="dinner-end">
            <Form.FloatingLabel label={END} className="text-secondary">
              <Form.Control
                type="time"
                value={dinnerEnd}
                onChange={(e) => {
                  setDinnerEnd(e.target.value);
                  context.patient.dinnerEnd = e.target.value;
                }}
                required
                disabled={override === true ? false : true} />
            </Form.FloatingLabel>
          </Form.Group>
          <Form.Group as={Col} sm={1} className="mt-2" controlId="overnight-start">
            <Form.FloatingLabel label={START} className="text-secondary">
              <Form.Control
                type="time"
                value={overnightStart}
                onChange={(e) => {
                  setOvernightStart(e.target.value);
                  context.patient.overnightStart = e.target.value;
                }}
                required
                disabled={override === true ? false : true} />
            </Form.FloatingLabel>
          </Form.Group>
          <Form.Group as={Col} sm={1} className="mt-2" controlId="overnight-end">
            <Form.FloatingLabel label={END} className="text-secondary">
              <Form.Control
                type="time"
                value={overnightEnd}
                onChange={(e) => {
                  setOvernightEnd(e.target.value);
                  context.patient.overnightEnd = e.target.value;
                }}
                required
                disabled={override === true ? false : true} />
            </Form.FloatingLabel>
          </Form.Group>
        </Row>
      </Card.Body>
      </Card>
    </Form>
  )
});
export default BglSettings;
